export const FORMATS = ['CODE_128', 'EAN_13', 'EAN_8', 'UPC_A', 'UPC_E', 'CODE_39', 'CODE_93', 'ITF', 'CODABAR', 'QR_CODE', 'DATA_MATRIX', 'PDF_417', 'AZTEC'];

export function uuid() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, n => n.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function createSession(scope, mode, params, querys) {
  return { version: 1, scope, mode, id: uuid(), started_at: new Date().toISOString(), closed: false, params: JSON.parse(JSON.stringify(params)), querys: JSON.parse(JSON.stringify(querys)), scans: [] };
}

export function sessionKey(session) { return `barcode:v1:${session.scope}:${session.id}`; }

export function saveSession(storage, session) {
  if (session.closed && session.scans.every(scan => scan.status === 'confirmed')) {
    storage.removeItem(sessionKey(session));
    return;
  }
  storage.setItem(sessionKey(session), JSON.stringify(session));
}

export function readSessions(storage, scope) {
  const sessions = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (!key.startsWith(`barcode:v1:${scope}:`)) continue;
    const session = JSON.parse(storage.getItem(key));
    if (session.version !== 1 || session.scope !== scope || !session.id || !Array.isArray(session.scans)
      || session.scans.some(s => !s.scan_id || typeof s.barcode !== 'string' || !['pending', 'sending', 'confirmed', 'error', 'uncertain'].includes(s.status))) {
      throw new Error('Session locale illisible. Les données sont conservées ; contactez votre administrateur.');
    }
    if (!session.closed || session.scans.some(s => s.status !== 'confirmed')) sessions.push(session);
  }
  return sessions.sort((a, b) => b.started_at.localeCompare(a.started_at));
}

export function recoverSession(session) {
  const copy = JSON.parse(JSON.stringify(session));
  copy.scans.forEach(s => {
    if (s.status === 'sending') s.status = copy.mode === 'burst' ? 'pending' : 'uncertain';
  });
  return copy;
}

export function applyResults(session, batch, results) {
  batch.forEach(scan => {
    const matches = results.filter(r => r.scan_id === scan.scan_id);
    const result = matches.length === 1 ? matches[0] : null;
    scan.status = result && ['confirmed', 'error'].includes(result.status) ? result.status : 'uncertain';
    scan.message = result ? (result.message || '') : 'Confirmation absente : vérifier ou renvoyer avec le même identifiant.';
  });
}

export function validateBatchResponse(session, batch, data) {
  if (!data || data.scan_session_id !== session.id || !Array.isArray(data.results)) {
    throw new Error(data && data.message || 'Réponse serveur invalide ou session différente.');
  }
  const seen = new Set();
  data.results.forEach(result => {
    if (!result || !batch.some(scan => scan.scan_id === result.scan_id) || seen.has(result.scan_id)) {
      throw new Error('Identifiants de scans incohérents dans la réponse serveur.');
    }
    seen.add(result.scan_id);
  });
}

// A code must disappear for several failed decoding frames before being captured again.
export function presenceGate(absenceMs = 700) {
  let key = '', lastSeen = 0;
  return {
    detect(code, format, now = Date.now()) {
      const next = `${format}:${code}`;
      const fresh = key !== next;
      key = next; lastSeen = now;
      return fresh;
    },
    missing(now = Date.now()) { if (now - lastSeen >= absenceMs) key = ''; },
  };
}
